import { api, planningAPI } from "../../axios";

export const actions = {

    // ExtensionActivity
    GetExtensionActivity(){
        return api.get("ExtensionActivity/GetAllExtensionActivities");
    },
    GetExtensionActivityByEP(context, data){
        return api.get(`ExtensionActivity/extensionProgram/${data}`);
    },
    GetSingleExtensionActivity(context, data){
        return api.get(`ExtensionActivity/${data}`);
    },
    UpdateExtensionActivity(context, data){
        return api.put(`ExtensionActivity/${data.id}`, data);
    },
    DeleteExtensionActivity(context, data){
        return api.delete(`ExtensionActivity/${data}`);
    },
    CreateExtensionActivity(context, data){
        return api.post(`ExtensionActivity/CreateExtensionActivity`, data);
    },

    // Beneficiaries
    GetActivityBeneficiary(context, data){
        return planningAPI.get(`ExtensionActivityBeneficiary/Get/ByExtensionActivityId/${data}`);
    },
    AddMultipleBeneficiary(context, data){
        return planningAPI.post(`ExtensionActivityBeneficiary/Add/Multiple/${data.id}`, data.array);
    },
    RemoveBeneficiary(context, data){
        return planningAPI.delete(`ExtensionActivityBeneficiary/Remove/${data}`);
    },
}